
const Logout = ({ width = 20, height = 20 }) => (
	<svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.9091 7.09091V3.90909C11.9091 2.85473 11.0544 2 10 2L4.90909 2C3.85473 2 3 2.85473 3 3.90909L3 15.3636C3 16.418 3.85473 17.2727 4.90909 17.2727H10C11.0544 17.2727 11.9091 16.418 11.9091 15.3636V12.1818M8.72727 7.09091L6.18182 9.63636M6.18182 9.63636L8.72727 12.1818M6.18182 9.63636L17 9.63637" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export default Logout;